import types from '../types'
import consts from '../../const'

const state = {
    width: 0,
    offsetY: 0,
    appMode: '',
    rendered: false,
    scrolled: false,
    language: 'kr'
}

const mutations = {
    [types.appState.mutations.updateWidth] (state, { width }) {
        state.width = width
    },
    [types.appState.mutations.updateAppMode] (state, { appMode }) {
        state.appMode = appMode
    },
    [types.appState.mutations.updateOffsetY] (state, { offsetY }) {
        state.offsetY = offsetY
    },
    [types.appState.mutations.updateRendered] (state, { rendered }) {
        state.rendered = rendered === true
    },
    [types.appState.mutations.updateScrolled] (state, { scrolled }) {
        state.scrolled = scrolled === true
    },
    [types.appState.mutations.updateLanguage] (state, { language }) {
        state.language = language
    }
}

const actions = {
    [types.appState.actions.updateWidth] ({ commit, state }, { width }) {
        let appMode = ''

        if (width < 1024) {
            appMode = consts.appState.appMode.mobile
        } else {
            appMode = consts.appState.appMode.pc
        }

        if (state.appMode !== appMode) {
            commit(types.appState.mutations.updateAppMode, { appMode })
        }
    },
    [types.appState.actions.updateOffsetY] ({ commit, state }, { offsetY }) {
        const scrolled = offsetY > consts.appState.scrollThreshold
        if (state.scrolled !== scrolled) {
            commit(types.appState.mutations.updateScrolled, { scrolled })
        }
    },
    [types.appState.actions.updateRendered] ({ commit }, { rendered }) {
        commit(types.appState.mutations.updateRendered, { rendered })
    },
    [types.appState.actions.updateLanguage] ({ commit }, { language }) {
        commit(types.appState.mutations.updateLanguage, { language })
    }
}

const getters = {
    [types.appState.getters.getWidth]: state => state.width,
    [types.appState.getters.getAppMode]: state => state.appMode,
    [types.appState.getters.isPC]: state => state.appMode === consts.appState.appMode.pc,
    [types.appState.getters.isRendered]: state => state.rendered === true,
    [types.appState.getters.isScrolled]: state => state.scrolled === true,
    [types.appState.getters.language]: state => state.language
}

export default {
    state,
    mutations,
    actions,
    getters
}
